/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import ReactDOM from 'react-dom/client';
import components from './components';
import './global/index.scss';

window.React = React;
(window as any).ReactDOM = ReactDOM;
(global as any).Components = components;
